
<template>
  <a>
    <span class="modal-body-text">The changes to your event have been requested.</span><br/>
    <span class="modal-body-text">ADURO will now review the event for approval.</span><br/>
  </a>
</template>

<script>
export default {
  name: 'change-submitted-body-modal'
}
</script>

<style lang="less">

</style>




// WEBPACK FOOTER //
// ChangeSubmitted.vue?32012a92